import { render, staticRenderFns } from "./ServiceTable.vue?vue&type=template&id=6774abd0&scoped=true"
import script from "./ServiceTable.vue?vue&type=script&lang=js"
export * from "./ServiceTable.vue?vue&type=script&lang=js"
import style0 from "./ServiceTable.vue?vue&type=style&index=0&id=6774abd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6774abd0",
  null
  
)

export default component.exports